

  // User profile classes - dynamic based on collapsed state
export const getSidebarUserProfileClasses = (isCollapsed: boolean) => ({
    container: "mt-auto pb-4",
    inner: `flex items-center ${
      isCollapsed ? 'p-2 justify-center' : 'p-3'
    } rounded-xl bg-white border border-gray-200 relative transition-all duration-200 cursor-pointer hover:bg-gray-50 group max-[1200px]:justify-center max-[1200px]:border-none max-[1200px]:p-0 max-[1200px]:hover:bg-transparent max-[1200px]:p-0 `,
    avatar: `w-10 h-10 rounded-full overflow-hidden ${
      isCollapsed ? '' : 'mr-3'
    } flex-shrink-0 max-[1200px]:mr-0`,
    info: `flex flex-col ${
      isCollapsed ? 'hidden' : 'block'
    } transition-opacity duration-200 max-[1200px]:hidden`,
    name: "text-sm font-semibold text-gray-900",
    email: "text-sm text-gray-500",
    statusIndicator: {
      base: `w-2.5 h-2.5 rounded-full absolute ${
        isCollapsed ? 'bottom-1 right-1' : 'bottom-1 left-8'
      } border-2 border-white max-[1200px]:bottom-1 max-[1200px]:right-1`,
      online: "bg-green-500",
      offline: "bg-gray-400",
      away: "bg-yellow-500",
    },
    chevron: `absolute top-1 right-1 text-gray-400 ${
      isCollapsed ? 'hidden' : 'block'
    } transition-opacity duration-200 max-[1200px]:hidden`,
    tooltip: `absolute left-full ml-2 px-3 py-2 bg-gray-900 text-white text-sm rounded opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 ${
      isCollapsed ? 'block' : 'hidden'
    } max-[1200px]:block`,
  });

  // Deprecated - keeping for backward compatibility but will be removed
export const userProfileClasses = {
    container: "mt-auto pb-4",
    inner: "flex items-center p-3 rounded-xl bg-white border border-gray-200 relative",
    avatar: "w-10 h-10 rounded-full overflow-hidden mr-3",
    info: "flex flex-col",
    name: "text-sm font-semibold text-gray-900",
    email: "text-sm text-gray-500",
    statusIndicator: {
      base: "w-2.5 h-2.5 rounded-full absolute bottom-1 left-8 border-2 border-white",
      online: "bg-green-500",
      offline: "bg-gray-400",
      away: "bg-yellow-500",
    },
    chevron: "absolute top-2 right-1 text-gray-400",
  }; 